<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="title-header">
      <h2>Confirme sua data de nascimento</h2>
    </div>
    <form [formGroup]="model" (ngSubmit)="submit()" #form>
      <mat-form-field appearance="outline">
        <mat-label class="input-label">Data de nascimento</mat-label>
        <input matInput inputmode="text" type="text" formControlName="birthDate" [mask]="masks.date"
          placeholder="dd/mm/aaaa" required>
        <mat-error *ngIf="model.get('birthDate')?.invalid">Data de
          nascimento inválida</mat-error>
      </mat-form-field>

    </form>
  </div>
</div>
<div class="footer-confirm-modal-list">

  <button mat-flat-button color="primary" class="btn-block" type="submit" (click)="submit()">
    Verificar
  </button>
</div>